<template>
  <Content class="goodsBox">
    <Tabs @on-click="choosetab">
      <TabPane
        :label="item.area_name"
        :name="item.area_id.toString()"
        v-for="(item, index) in tabs"
        :key="index"
      >
        <Form id="searchForm" :model="formItem" :label-width="80" inline>
          <FormItem label="车辆名称">
            <Input v-model="formItem.key" placeholder="模糊搜索" clearable />
          </FormItem>
          <FormItem :label-width="20">
            <Button type="primary" @click="search">查询</Button>
            <Button style="margin-left: 8px" @click="clear">重置</Button>
          </FormItem>
          <FormItem class="action-buttons-right">
            <Button type="primary" @click="show()">添加车辆</Button>
            <Button type="primary" style="margin-left: 8px" @click="showPhotoManager()">照片管理</Button>
            <Button type="primary" style="margin-left: 8px" @click="showTextManager()">文案管理</Button>
            <Button 
              type="success" 
              icon="ios-pulse" 
              style="margin-left: 8px" 
              @click="goToRealTimeMonitor"
            >
              实时监控
            </Button>
          </FormItem>
        </Form>
        <Table
          :columns="columns"
          :data="tableData"
          :height="tablesHeight"
          border
        ></Table>
        <Page
          class="table_page_css"
          v-show="total"
          :total="total"
          :current="searchInfo.pageNo"
          :page-size="searchInfo.pageSize"
          :page-size-opts="pageSizeOpts"
          @on-change="pageNoChange"
          @on-page-size-change="pageSizeChange"
          show-sizer
          show-elevator
          show-total
        />
      </TabPane>
    </Tabs>
    <AddUpdate @reload="getList" ref="AddUpdate"></AddUpdate>
    <PhotoManager @reload="getList" ref="PhotoManager"></PhotoManager>
    <TextManager @reload="getList" ref="TextManager"></TextManager>
  </Content>
</template>
<script>
import { CarList, CarDel } from '@/api/car'
import AddUpdate from './carAddUpdate'
import PhotoManager from './PhotoManager'
import TextManager from './TextManager'
export default {
  name: 'Roles',
  components: {
    AddUpdate,
    PhotoManager,
    TextManager
  },
  data() {
    return {
      columns: [
        {
          type: 'index',
          width: 60,
          align: 'center',
        },
        {
          title: '车辆名称',
          key: 'car_name',
        },
        {
          title: '计费价格',
          key: 'car_price',
        },
        {
          title: '车辆描述',
          key: 'car_desc',
          render: (h, params) => {
            // 车辆描述应该显示真正的描述信息，不应该显示状态
            // 如果cardesc是状态值（如"空闲"），则不显示
            const statusKeywords = ['空闲', '前往', '到达', '开仓', '关仓', '还车成功', '故障', '维护中', 'IDLE', 'GOING', 'ARRIVED', 'OPENING', 'CLOSING', 'RETURNED', 'FAULT', 'MAINTENANCE']
            const desc = params.row.car_desc || params.row.cardesc || ''
            // 如果描述是状态关键词，则不显示（因为状态应该在状态列显示）
            if (statusKeywords.includes(desc)) {
              return h('div', '-')
            }
            return h('div', desc || '-')
          },
        },
        {
          title: '车辆标识',
          key: 'car_ref',
        },
        {
          title: '车辆状态',
          key: 'status',
          render: (h, params) => {
            const statusMap = {
              'IDLE': '空闲',
              'GOING': '前往',
              'ARRIVED': '到达',
              'OPENING': '开仓',
              'CLOSING': '关仓',
              'RETURNED': '还车成功',
              'FAULT': '故障',
              'MAINTENANCE': '维护中',
              '空闲': '空闲',  // 兼容中文状态
              '前往': '前往',
              '到达': '到达'
            }
            // 优先使用status字段，如果没有则尝试其他可能的字段
            let status = params.row.status || params.row.type_mes || params.row.typemes
            
            // 如果状态为空，尝试从其他字段获取
            if (!status) {
              // 检查是否有其他包含状态信息的字段
              status = params.row.vehicleStatus || params.row.carStatus
            }
            
            // 如果状态是中文，直接使用；如果是英文，转换为中文
            const statusText = statusMap[status] || status || '无'
            return h('div', statusText)
          },
          align: 'center',
        },
        {
          title: '是否在线',
          key: 'online',
          render: (h, params) => {
            return h('div', params.row.online ? '在线' : '离线')
          },
          align: 'center',
        },
        {
          title: '操作',
          key: 'action',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                  },
                  on: {
                    click: () => {
                      this.show(params.row)
                    },
                  },
                },
                '编辑',
              ),
              h(
                'Poptip',
                {
                  props: {
                    confirm: true,
                    transfer: true,
                    title: '您确认删除这条内容吗？',
                  },
                  on: {
                    'on-ok': () => {
                      this.remove(params.row._id)
                    },
                  },
                },
                [
                  h(
                    'Button',
                    {
                      props: {
                        type: 'error',
                        size: 'small',
                      },
                      style: {
                        marginRight: '5px',
                      },
                    },
                    '删除',
                  ),
                ],
              ),
            ])
          },
        },
      ],
      tableData: [],
      total: 0,
      searchInfo: {
        pageNo: 1,
        pageSize: 5,
      },
      pageSizeOpts: [1, 2, 5, 10],
      formItem: {
        key: '',
      },
      tablesHeight: 0,
      seltabsareaid: null,
    }
  },
  computed: {
    // 从Vuex store获取区域列表，响应式更新
    tabs() {
      try {
        const areas = this.$store.state.areas
        if (areas && areas !== 'null' && areas !== '') {
          const areaList = JSON.parse(areas)
          
          // 修复错误的location字段
          const fixedAreaList = areaList.map(area => {
            // 检查location字段的坐标是否有效
            if (area.location && area.location.coordinates) {
              const [lng, lat] = area.location.coordinates
              // 如果坐标超出有效范围，使用center字段的值
              if (lng < -180 || lng > 180 || lat < -90 || lat > 90) {
                console.warn(`区域 ${area.area_name} (ID: ${area.area_id}) 的location坐标无效: [${lng}, ${lat}]，使用center字段的值`)
                if (area.center && area.center.coordinates) {
                  area.location = {
                    type: 'Point',
                    coordinates: area.center.coordinates
                  }
                } else {
                  // 如果center也没有，删除location字段
                  delete area.location
                }
              }
            }
            return area
          })
          
          // 如果当前选中的区域ID为空，设置第一个区域为默认选中
          if (!this.seltabsareaid && fixedAreaList.length > 0) {
            this.$nextTick(() => {
              this.seltabsareaid = fixedAreaList[0].area_id.toString()
              this.getList()
            })
          }
          return fixedAreaList
        }
        return []
      } catch (error) {
        console.error('解析区域数据失败:', error)
        return []
      }
    }
  },
  created() {
    console.log('区域数据:', this.$store.state.areas)
    // 初始化默认选中的区域ID
    if (this.tabs.length > 0 && !this.seltabsareaid) {
      this.seltabsareaid = this.tabs[0].area_id.toString()
    }
  },

  methods: {
    // 切换标签页时触发的方法
    choosetab(areaId) {
      this.seltabsareaid = areaId // 更新当前选中的区域 ID
      this.getList() // 重新获取列表数据
    },

    // 设置表格高度的方法
    setTablesHeight() {
      let aH = 0 // 初始化表格高度变量
      let oA = document.getElementById('app') // 获取应用容器元素
      let oH = oA.clientHeight || oA.offsetHeight // 获取应用容器的高度
      let sA = document.getElementById('searchForm') // 获取搜索表单元素
      let sH = sA.clientHeight || sA.offsetHeight // 获取搜索表单的高度
      aH = oH - sH - 265 // 计算表格的高度（减去搜索表单高度和固定值265）
      this.tablesHeight = aH // 更新表格高度数据属性
    },

    // 获取车辆列表数据的方法
    getList() {
      CarList({ ...this.searchInfo, area_id: this.seltabsareaid })
        .then((res) => {
          if (res.data.code === 200) {
            const data = res.data
            this.tableData = data.data
            
            // 如果后端返回的是驼峰形式，需要在前端转换为下划线形式
            if (this.tableData && this.tableData.length > 0) {
              this.tableData.forEach(item => {
                // 字段名转换：驼峰转下划线（保持原有字段，同时添加下划线版本）
                if (item.carname !== undefined && item.car_name === undefined) {
                  item.car_name = item.carname;
                }
                if (item.carprice !== undefined && item.car_price === undefined) {
                  item.car_price = item.carprice;
                }
                if (item.cardesc !== undefined && item.car_desc === undefined) {
                  item.car_desc = item.cardesc;
                }
                if (item.carref !== undefined && item.car_ref === undefined) {
                  item.car_ref = item.carref;
                }
                
                // 处理状态字段：优先使用status，如果没有则尝试其他字段
                // 注意：不要将cardesc（描述）误认为status（状态）
                if (!item.status) {
                  if (item.type_mes !== undefined && item.type_mes !== null && item.type_mes !== '') {
                    item.status = item.type_mes;
                  } else if (item.typemes !== undefined && item.typemes !== null && item.typemes !== '') {
                    item.status = item.typemes;
                  } else if (item.vehicleStatus !== undefined && item.vehicleStatus !== null && item.vehicleStatus !== '') {
                    item.status = item.vehicleStatus;
                  } else if (item.carStatus !== undefined && item.carStatus !== null && item.carStatus !== '') {
                    item.status = item.carStatus;
                  }
                  // 注意：不要将cardesc作为status使用，即使cardesc的值看起来像状态
                }
                
                if (item.areaId !== undefined && item.area_id === undefined) {
                  item.area_id = item.areaId;
                }
                
                // 调试输出（可以在控制台查看实际数据结构）
                console.log('车辆数据:', {
                  car_name: item.car_name || item.carname,
                  car_desc: item.car_desc || item.cardesc,
                  status: item.status,
                  type_mes: item.type_mes,
                  typemes: item.typemes,
                  raw: item
                })
              });
            }
            
            this.total = data.total
          } else {
            this.$Message.error(res.data.msg)
          }
        })
        .catch((err) => {
          this.$Message.error(err)
        })
    },

    // 搜索方法
    search() {
      this.searchInfo = {
        // 更新搜索信息
        key: this.formItem.key, // 搜索关键字
        pageNo: 1, // 重置页码为1
        pageSize: this.searchInfo.pageSize, // 保持每页显示数量不变
      }
      this.getList() // 重新获取列表数据
    },

    // 清除搜索条件的方法
    clear() {
      this.formItem = {
        // 重置表单数据
        key: '', // 清空搜索关键字
      }
      this.searchInfo = {
        // 重置搜索信息
        pageNo: 1, // 重置页码为1
        pageSize: 5, // 重置每页显示数量为5
      }
      this.getList() // 重新获取列表数据
    },


    // 显示添加或更新车辆信息模态框的方法
    show(params) {
      if (params) {
        // 确保字段名称正确转换
        const convertedParams = {
          ...params,
          car_name: params.carname || params.car_name,
          car_price: params.carprice || params.car_price,
          car_desc: params.cardesc || params.car_desc,
          car_ref: params.carref || params.car_ref,
          area_id: params.areaId || params.area_id
        }
        this.$refs.AddUpdate.init(convertedParams)
      } else {
        this.$refs.AddUpdate.init({ area_id: this.seltabsareaid })
      }
    },

    // 删除车辆信息的方法
    remove(_id) {
      CarDel({ _id: _id }) // 调用CarDel API删除车辆信息
        .then((res) => {
          // 处理成功的响应
          if (res.data.code === 200) {
            // 如果响应码为200，表示删除成功
            this.$Message.success('删除成功') // 显示成功消息
            this.getList() // 重新获取列表数据
          } else {
            this.$Message.error(res.data.msg) // 如果响应码不是200，显示错误消息
          }
        })
        .catch((err) => {
          // 处理错误的响应
          this.$Message.error(err) // 显示错误消息
        })
    },

    // 页码改变时触发的方法
    pageNoChange(current) {
      this.searchInfo.pageNo = current // 更新当前页码
      this.getList() // 重新获取列表数据
    },
    // 每页显示数量改变时触发的方法
    pageSizeChange(val) {
      this.searchInfo.pageNo = 1
      this.searchInfo.pageSize = val
      this.getList()
    },

    // 显示照片管理模态框
    showPhotoManager() {
      this.$refs.PhotoManager.init({ area_id: this.seltabsareaid })
    },

    // 显示文案管理模态框
    showTextManager() {
      this.$refs.TextManager.init({ area_id: this.seltabsareaid })
    },

    // 跳转到实时监控页面，传递当前区域ID
    goToRealTimeMonitor() {
      // 获取当前选中的区域ID
      const currentAreaId = this.seltabsareaid
      if (currentAreaId) {
        // 传递区域ID作为路由参数
        this.$router.push({ 
          name: 'carRealtime', 
          query: { area_id: currentAreaId } 
        })
      } else {
        // 如果没有选中区域，直接跳转
        this.$router.push({ name: 'carRealtime' })
      }
    },
  },
  mounted() {
    this.getList()
    setTimeout(() => {
      this.setTablesHeight()
    }, 50)
    window.onresize = () => {
      this.setTablesHeight()
    }
  },
}
</script>
<style lang="less" scoped>
.goodsBox {
  .ivu-form-inline .ivu-form-item {
    margin-right: 8px;
    margin-bottom: 16px;
    vertical-align: top;
  }
  
  // 确保搜索表单可以正常换行和对齐
  #searchForm {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 20px;
    
    .ivu-form-item {
      display: inline-block;
      margin-bottom: 0;
      
      // 右侧操作按钮靠右对齐
      &.action-buttons-right {
        margin-left: auto;
        margin-right: 0;
      }
    }
  }
}
</style>
